// src/pages/KundeViewPage.jsx
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Heading, Text, VStack, Button } from "@chakra-ui/react";
import axios from "axios";

export default function KundeViewPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [kunde, setKunde] = useState(null);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/kunden/${id}`)
      .then((res) => setKunde(res.data))
      .catch((err) => console.error("Fehler beim Laden des Kunden:", err));
  }, [id]);

  if (!kunde) return <Text>Lade Kundendaten...</Text>;

  return (
    <Box maxW="2xl" mx="auto" mt={10} p={8} bg="white" borderRadius="xl" boxShadow="lg">
      <Heading size="md" mb={6}>
        Kundendetails
      </Heading>

      <VStack align="stretch" spacing={6}>
        <Detail label="Anrede " value={kunde.anrede} />
        <Detail label="Vorname " value={kunde.vorname} />
        <Detail label="Nachname " value={kunde.nachname} />
        <Detail label="Firma " value={kunde.firma} />
        <Detail label="Straße / Hausnummer " value={kunde.strasse} />
        <Detail label="PLZ / Ort " value={kunde.plzOrt} />
        <Detail label="Telefon " value={kunde.telefon} />
        <Detail label="Mobil " value={kunde.mobil} />
        <Detail label="Email " value={kunde.email} />


        <Detail label="Ansprechpartner-Vorname " value={kunde.ansprechpartnerVorname} />
        <Detail label="Ansprechpartner-Nachname " value={kunde.ansprechpartnerNachname} />
        <Detail label="Ansprechpartner-Telefon " value={kunde.ansprechpartnerTelefon} />
        <Detail label="Ansprechpartner-Mobil " value={kunde.ansprechpartnerMobil} />
        <Detail label="Ansprechpartner-Email " value={kunde.ansprechpartnerEmail} />
        
        
        <Detail label="Hinweis" value={kunde.hinweis} />
      </VStack>

      <Button mt={6} colorScheme="blue" onClick={() => navigate(-1)}>
        Zurück
      </Button>
    </Box>
  );
}

function Detail({ label, value }) {
  return (
    <Text>
      <Text as="span" fontWeight="semibold">
        {label}:
      </Text>{" "}
      {value || "-"}
    </Text>
  );
}